import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_TRAVEL_INTERRUPTION_STATE,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    travelInterruption: 'false',
    enableTime: null,
    areYouInterruptingTheTripDueToMedicalReasons: 'false',
    schoolNameForInterruption: '',
    reasonsForTripInterruption: [],
    companyNameTravelInterruption: '',
    addressTravelInterruption: '',
    cityTravelInterruption: '',
    stateTravelInterruption: '',
    zipCodeTravelInterruption: '',
    contactTravelInterruption: '',
    phoneNumberTravelInterruption: '',
    includedInPackage: '',
    dateTripInterrupted: '',
    reasonForInterruption: '',
    nameOfPersonHavingSickness: '',
    dateOfBirth: '',
    relationshipToClaimant: '',
    dateSicknessOrInjuryBegan: '',
    dateEnded: '',
    natureOfSicknessOrInjury: '',
    periodOfHospitalization: '',
    lossInformationItems: [],
    fromDate: '',
    toDate: '',
    dateOfInitialPaymentDeposit: '',
    insureds: [],
  },
  errors: [],
});

const initialTravelInterruptionState = {
  form: {
    travelInterruption: 'false',
    reasonsForTripInterruption: [],
    companyNameTravelInterruption: '',
    addressTravelInterruption: '',
    cityTravelInterruption: '',
    stateTravelInterruption: '',
    zipCodeTravelInterruption: '',
    contactTravelInterruption: '',
    phoneNumberTravelInterruption: '',
    includedInPackage: '',
    dateTripInterrupted: '',
    nameOfPersonHavingSickness: '',
    dateOfBirth: '',
    relationshipToClaimant: '',
    dateSicknessOrInjuryBegan: '',
    dateEnded: '',
    natureOfSicknessOrInjury: '',
    periodOfHospitalization: '',
    lossInformationItems: [],
    fromDate: '',
    toDate: '',
    insureds: [],
  },
};

function tripCancellationStepReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_TRAVEL_INTERRUPTION_STATE:
      return state
           .setIn(['form', 'lossInformationItems'], [])
           .mergeDeep(initialTravelInterruptionState);
    default:
      return state;
  }
}

export default tripCancellationStepReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.TripInterruptionStep/reducer.js